/** Long-form region names in Mapbox-style place labels → AU codes (longest first). */
const AU_STATE_ABBREVIATIONS: [RegExp, string][] = [
  [/Australian Capital Territory/gi, 'ACT'],
  [/New South Wales/gi, 'NSW'],
  [/Northern Territory/gi, 'NT'],
  [/South Australia/gi, 'SA'],
  [/Western Australia/gi, 'WA'],
  [/Queensland/gi, 'QLD'],
  [/Victoria/gi, 'VIC'],
  [/Tasmania/gi, 'TAS'],
];

export function abbreviateAustralianStatesInLabel(label: string): string {
  return AU_STATE_ABBREVIATIONS.reduce(
    (acc, [pattern, code]) => acc.replace(pattern, code),
    label
  );
}
